import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../style/user/Profile.css";
import { useAuth } from "../../context/AuthContext";

export default function Profile({ logout, onMenuClick }) {
  const { currentUser } = useAuth();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();

  const handleEditProfile = () => navigate("/edit-profil");

  return (
    <div className="profile-container">
      <div className="profile-card">
        <h2 className="profile-title">Profile</h2>
        <div className="profile-info">
          {currentUser?.profile_image ? (
            <img
              src={currentUser.profile_image}
              alt="Profile"
              className="profile-pic"
              onError={(e) => (e.target.style.display = "none")}
            />
          ) : (
            <div className="profile-fallback">
              {currentUser?.name ? currentUser.name.charAt(0).toUpperCase() : "U"}
            </div>
          )}
          <div>
            <p className="profile-name">{currentUser?.name}</p>
            <p className="profile-email">{currentUser?.email}</p>
          </div>
        </div>

        <div className="profile-action" onClick={handleEditProfile}>
          <span className="profile-icon">👤</span>
          <span>Edit Profile</span>
        </div>

        <div className="logout-button" onClick={() => setShowLogoutModal(true)}>
          <span className="logout-icon">↪</span>
          <span>Log Out</span>
        </div>
      </div>

      {showLogoutModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p className="modal-title">Are you sure want to log out?</p>
            <p className="modal-text">
              You will be logged out of your account and may need to log in again to continue using the services.
            </p>
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => setShowLogoutModal(false)}>Cancel</button>
              <button className="btn-confirm" onClick={logout}>Yes, Sure</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
